import React, { useState, useEffect } from "react";
import "./style.css"

function HeroImageUpload({ onImageUploaded }) {
  const [imageUrl, setImageUrl] = useState(null);
  const [altText, setAltText] = useState("");
   const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    // Fetch the current hero image
    fetch("https://homchang.in/hero_image.php")
      .then((response) => response.json())
      .then((data) => {
        
        if (data.success && data.heroImage) {
          setImageUrl(data.heroImage.ImageURL);
          setAltText(data.heroImage.AltText);
        }
      });
  }, []);

  // Cloudinary upload handler
  const handleUpload = () => {
    setIsUploading(true);
    window.cloudinary.openUploadWidget(
      {
        cloudName: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME,
        uploadPreset: "Hero_Images",
        sources: ["local", "url"],
        multiple: false,
        folder: "hero_images",
        clientAllowedFormats: ["jpg", "png", "jpeg"],
        maxImageFileSize: 2000000,
      },
      (error, result) => {
        setIsUploading(false);
        if (!error && result && result.event === "success") {
          setImageUrl(result.info.secure_url);
          console.log(imageUrl);
        }
      }
    );
  };

  // Submit or update the uploaded image in the database
  const handleSubmit = async () => {
    if (!imageUrl) {
        alert("Please upload an image first.");
        return;
    }

    const response = await fetch("https://homchang.in/hero_image.php", {
        method: "PUT", // Always use PUT to update the image
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ImageURL: imageUrl, AltText: altText }),
    });

    const data = await response.json();
    if (data.success) {
        alert("Image updated successfully!");
        if (onImageUploaded) onImageUploaded(imageUrl);
    } else {
        alert("Error updating image: " + data.message);
    }
};

  // Remove the uploaded image from the database
  const handleRemove = () => {
    setImageUrl(null);
    setAltText("");
    
  };

  return (
    <div className="flex flex-col items-center p-6 bg-gray-100 rounded-lg shadow-lg max-w-lg mx-auto">
      <button
        onClick={handleUpload}
        className="bg-blue-500 text-white px-4 py-2 rounded-md shadow-md hover:bg-blue-600 transition"
      >
        {isUploading ? 'Uploading...' : 'Upload Hero Image'}
      </button>
      {isUploading && (
               <div className="loading-spinner">
                 
                  Loading...
               </div>
           )}
      {imageUrl && (
        <div className="mt-4 flex flex-col items-center">
          {console.log("Rendering Image with URL:", imageUrl)}
          <img
            src={imageUrl}
            alt={altText || "Hero Image"}
            className="w-64 h-40 object-cover rounded-lg shadow-md border"
          />
          <input
            type="text"
            placeholder="Alt text"
            value={altText}
            onChange={(e) => setAltText(e.target.value)}
            className="mt-2 px-3 py-2 border rounded-md w-full text-gray-700"
          />
          <div className="mt-4 flex gap-3">
            <button
              onClick={handleSubmit}
              className="bg-green-500 text-white px-4 py-2 rounded-md shadow-md hover:bg-green-600 transition"
            >
              Submit Image
            </button>
            <button
              onClick={handleRemove}
              className="bg-red-500 text-white px-4 py-2 rounded-md shadow-md hover:bg-red-600 transition"
            >
              Remove Image
            </button>
          </div>
        </div>
      )}
    </div>
    
  );
}

export default HeroImageUpload;
